import { deliveryChargeTypeColor, deliveryChargeTypeNameLocale, } from '@/constants/storeManagement/deliveryChargeDialog';
import { createWeekObject } from '@/constants/week';
import DeliveryCharge from '@/entity/DeliveryCharge';
export default class DeliveryChargeVM extends DeliveryCharge {
    // eslint-disable-next-line no-useless-constructor
    constructor(data) {
        super(data);
    }
    /**
     * 색상
     */
    get color() {
        return deliveryChargeTypeColor[this.type];
    }
    /**
     * 구분 명칭
     */
    get printType() {
        return deliveryChargeTypeNameLocale[this.type];
    }
    /**
     * 요일 프린트
     */
    get printWorkingDay() {
        const week = createWeekObject();
        const myWorkDay = this.workingDay;
        myWorkDay.forEach((d) => {
            week[d].isWork = true;
        });
        return week;
    }
}
